import { render, staticRenderFns } from "./PromotionCreate.vue?vue&type=template&id=2545dbf6&"
import script from "./PromotionCreate.vue?vue&type=script&lang=js&"
export * from "./PromotionCreate.vue?vue&type=script&lang=js&"
import style0 from "./PromotionCreate.vue?vue&type=style&index=0&id=2545dbf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports